import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { AssetService } from '@app/_services';
import { Asset, AssetTypeName } from '@app/_models/_DTOs/asset';
import { ITuple } from '@app/_models/tuple';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { NzDrawerRef, NzOptionComponent, UploadFile } from 'ng-zorro-antd';
import { AssetHistory, AssetHistoryActionName } from '@app/_models/_DTOs/assetHistory';
import { AssetHistoryActionType } from '@app/_models/assetHistoryActionType';
import { AssetViewModel } from '@app/_models/_viewModels/asset.viewmodel';
import { LocationService } from '@app/_services/location.service';
import { DepartmentService } from '@app/_services/department.service';
import { SupplierService } from '@app/_services/supplier.service';
import { EmployeeService } from '@app/_services/employee.service';
import { AssetGroup } from '@app/_models/_DTOs/assetGroup';
import { AssetGroupService } from '@app/_services/assetGroup.service';
import { Department } from '@app/_models/_DTOs/department';
import { Supplier } from '@app/_models/_DTOs/supplier';
import { Employee } from '@app/_models/_DTOs/employee';
import { AssetType } from '@app/_models/enums/assetType';
import { map } from 'rxjs/internal/operators/map';

import { NzMessageService } from 'ng-zorro-antd';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Media } from '@app/_models/_DTOs/media';
import { Subject } from 'rxjs';
import { DocumentService } from '@app/_services/document.service';
import { Location } from '@app/_models/_DTOs/location';
import { AssetDetailsComponent } from '@app/assets/asset-details/asset-details.component';
import { ResizeService } from '@app/_services/resize.service';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { AssetEditorComponent } from '@app/assets/asset-editor/asset-editor.component';
import { Sort } from '@app/_models/sort';
import { SortDirection } from '@app/_models/enums/sortDirection';

@Component({
  selector: "app-excel-uploader",
  templateUrl: "./excel-uploader.component.html",
  styleUrls: ["./excel-uploader.component.css"],
})
export class ExcelUploaderComponent implements OnInit {
  @Input() endpoint: string;
  @Input() disabled: boolean = false;

  isUploading: boolean = false;
  uploadPercentage: number = 0;
  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: true,
    hidePreviewIconInNonImage: true,
  };
  fileList: UploadFile[] = [];

  apiUrl: string;

  errorMessages = {};

  constructor(
    private assetService: AssetService,
    private messageService: NzMessageService
  ) {
    this.apiUrl = environment.apiUrl;
  }

  ngOnInit() { }

  beforeUpload = (file: UploadFile): boolean => {
    this.fileList = this.fileList.concat(file);
    return false;
  };

  uploadExcel(form: NgForm) {
    this.uploadPercentage = 0;
    this.isUploading = true;

    const formData = new FormData();
    this.fileList.forEach((file: any) => {
      formData.append("files", file);
    });

    this.assetService.uploadAssetExcel(formData, this.endpoint).subscribe(
      (event) => {
        if (event.type === HttpEventType.UploadProgress)
          this.uploadPercentage = Math.round(
            (100 * event.loaded) / event.total
          );
        else if (event.type === HttpEventType.Response) {
          this.messageService.create("success", "Podaci uspješno ažurirani.");
          this.isUploading = false;
          this.uploadPercentage = 0;
          this.fileList = [];

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(event.body);
          }
          else {
            var fileUrl = URL.createObjectURL(event.body);

            var anchor = document.createElement("a");
            anchor.download = "Izvještaj.xlsx";
            anchor.href = fileUrl;
            anchor.click();
          }
        }
      },
      (error) => {
        // Error is handled here, so it should not propagate to interceptors
        this.fileList = [];
        if (error.error && error.error.ParamName) {
          if (form.controls[error.error.ParamName]) {
            form.controls[error.error.ParamName].setErrors({ custom: true });
            var errorMessage = error.error.Message.split("Parameter name")[0];
            this.errorMessages[error.error.ParamName] = errorMessage;
          }
        }
        this.isUploading = false;
        this.uploadPercentage = 0;
      }
    );
  }
}
